// src/Platform/Tabs/Chatbot/ConnectionSettings.js

import React from 'react';
import './Voicebot.css';

function Voicebot({
  openAIAPIKey,
  setOpenAIAPIKey,
}) {
  return (
    <div className="connection-settings">
      {/* Removed OpenAI Assistant Key input */}
    </div>
  );
}

export default Voicebot;
